/* eslint-disable import/prefer-default-export */
import {
  cilPin,
  cilSpeedometer,
  cilNoteAdd,
  cilNotes,
  cilChevronRight,
  cilChevronLeft,
  cilCheck,
  cilCheckAlt,
  cilColorBorder,
  cilMoon,
  cilSun,
  cilSettings,
  cilChart,
  cilUser,
  cilLockLocked,
  cilPencil,
  cilTrash,
  cilGroup,
  cilLink,
  cilShortText,
  cilEnvelopeClosed,
  cilX,
  cilTags,
  cilDollar,
  cilSearch,
  cilCheckCircle,
  cilZoomIn,
  cilZoomOut,
  cilList,
  cilReload,
  cilBell,
  cilArrowTop,
  cilArrowBottom,
  cilListRich,
  cilCalendar,
  cilSwapVertical,
  cilPlus,
  cilAccountLogout,
  cilLockUnlocked,
  cilInfo,
  cilGraph,
  cilWarning,
  cilListNumbered,
  cilPeople,
  cilCommentSquare,
  cilChatBubble,
  cilUserPlus,
  cibAddthis,
  cilLevelUp,
  cilImage,
  cilLightbulb,
  cilCloudUpload,
  cilExternalLink,
  cilTag,
  cilBarChart,
  cilShare,
  cilPen,
  cilClipboard,
} from '@coreui/icons';
import { sygnet } from './sygnet';
import { logo } from './logo';
import { logoNegative } from './logo-negative';

export const icons = {
  logo,
  sygnet,
  logoNegative,
  cilPin,
  cilPlus,
  cilSpeedometer,
  cilNoteAdd,
  cilNotes,
  cilChevronRight,
  cilChevronLeft,
  cilCheck,
  cilColorBorder,
  cilMoon,
  cilSun,
  cilSettings,
  cilChart,
  cilUser,
  cilLockLocked,
  cilPencil,
  cilTrash,
  cilGroup,
  cilLink,
  cilShortText,
  cilEnvelopeClosed,
  cilX,
  cilCheckAlt,
  cilDollar,
  cilTags,
  cilSearch,
  cilCheckCircle,
  cilZoomIn,
  cilZoomOut,
  cilList,
  cilReload,
  cilBell,
  cilArrowTop,
  cilArrowBottom,
  cilListRich,
  cilAccountLogout,
  cilCalendar,
  cilSwapVertical,
  cilLockUnlocked,
  cilInfo,
  cilGraph,
  cilWarning,
  cilListNumbered,
  cilPeople,
  cilCommentSquare,
  cilChatBubble,
  cilUserPlus,
  cibAddthis,
  cilLevelUp,
  cilImage,
  cilLightbulb,
  cilCloudUpload,
  cilExternalLink,
  cilTag,
  cilBarChart,
  cilShare,
  cilPen,
  cilClipboard,
};
